<template>
  <!-- Modal login-->
  <div id="modal-login">
    <div
      id="modalLogin"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              &times;
            </button>
          </div>
          <div class="modal-body pl-5 pr-5">
            <p class="title mb-1">
              Log In
            </p>
            <p class="subtitle text-muted">
              sebagai:
            </p>
            <div class="row">
              <div class="col-lg-6">
                <div class="card border-0 text-center w-100">
                  <div class="card-body p-2">
                    <button class="btn btn-light btn-block"> 
                      <a
                        :href="linkShipPage"
                        class="card-link"
                      >Ship Owner</a>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="card border-0 text-center w-100">
                  <div class="card-body p-2">
                    <button class="btn btn-light btn-block"> 
                      <a
                        :href="linkCargoPage"
                        class="card-link"
                      >Cargo Owner</a>
                    </button>
                  </div>
                </div>
              </div>
              <!-- <div class="card text-center w-100">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6">
                      <a href="https://dev.ship.zonasea.com" class="card-link">Ship Owner</a>
                    </div>
                    <div class="col-lg-6">
                      <a href="https://dev.cargo.zonasea.com" class="card-link">Cargo Owner</a>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
            <p class="subtitle mt-4 text-muted">
              Belum terdaftar sebagai member?
            </p>
            <div class="row mt-4 mb-4">
              <div class="col-md-12">
                <button
                  class="btn btn-primary btn-block mx-0"
                  data-toggle="modal"
                  data-target="#modalRegister"
                  data-dismiss="modal"
                >
                  Sign Up
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      linkShipPage: process.env.VUE_APP_SHIP_URL,
      linkCargoPage: process.env.VUE_APP_CARGO_URL
    }
  }
};
</script>

<style></style>
